import { useLanguage } from "@/context/LanguageContext";
import { StreamingLinks } from "@/components/StreamingLinks";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="footer" className="border-t border-ivory/10 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
          <div>
            <button data-testid="footer-logo" onClick={() => scrollToId("home")} className="flex items-center">
              <img src="/assets/logo-red.png" alt="Giovanni Costello" className="h-12 w-auto" />
            </button>
            <p className="mt-4 gc-eyebrow !text-gold/60">{t.footer.tagline}</p>
          </div>
          <div>
            <p className="gc-eyebrow mb-4 !text-[9px]">{t.footer.follow}</p>
            <StreamingLinks variant="hero" />
          </div>
        </div>
        <div className="gc-gold-line mt-12" />
        <div className="mt-8 text-[11px] tracking-[0.15em] uppercase text-dim">
          <span>© Giovanni Costello Entertainment · GLM Music · Fine Music</span>
        </div>
      </div>
    </footer>
  );
};
